import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h4> 404!  page not found </h4>
    </div>
  );
};

export default NotFound;